import { Group } from '../group.model';
import { waiting, publicWaiting } from '../routes/remote-waiting';

import {
  portalOfferDetail,
  portalCustomerList,
  portalMemberProfile,
  portalBilling,
  portalLocations,
  portalLoyaltyTransaction,
  portalLoyaltyRewards,
  portalSellCoinsCampaignCreate
} from '../routes/portal';

const routes = [
  waiting,
  publicWaiting,
  portalCustomerList,
  portalOfferDetail,
  portalMemberProfile,
  portalBilling,
  portalLocations,
  portalLoyaltyTransaction,
  portalLoyaltyRewards,
  portalSellCoinsCampaignCreate
];

const portalGroup = new Group('portal', 'Portal', routes, {
  superRoot: false,
  hidden: true
});

export { portalGroup };
export default portalGroup;
